/* One motion contract for current components and future animation work. */
(function () {
  'use strict';
  if (window.SPQRMotion) return;
  var preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ease = 'cubic-bezier(0.625, 0.05, 0, 1)';
  var gsapPath = 'M0,0 C0.625,0.05 0,1 1,1';
  window.SPQRMotion = Object.freeze({
    ease: ease,
    get reducedMotion() { return preference.matches; },
    duration: function (kind) {
      if (preference.matches) return 0;
      return { fast: 180, select: 280, open: 360, close: 260, page: 220 }[kind] || 280;
    },
    registerGSAP: function (gsap, CustomEase) {
      if (!gsap || !CustomEase) return false;
      gsap.registerPlugin(CustomEase);
      CustomEase.create('osmo', gsapPath);
      gsap.defaults({ ease: 'osmo' });
      return true;
    }
  });
  // Reuse an existing GSAP runtime if a future section supplies it; no extra download today.
  window.SPQRMotion.registerGSAP(window.gsap, window.CustomEase);
  preference.addEventListener('change', function () {
    document.dispatchEvent(new CustomEvent('spqr:motion-preference', { detail: { reducedMotion: preference.matches } }));
  });
})();
